import { render } from "./Live.vue?vue&type=template&id=59f0b478"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
script.render = render

export default script